/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer3_settings = {
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_settings" | "CommentContainer_settings">;
    readonly " $refType": "ReplyListContainer3_settings";
};
export type ReplyListContainer3_settings$data = ReplyListContainer3_settings;
export type ReplyListContainer3_settings$key = {
    readonly " $data"?: ReplyListContainer3_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer3_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer3_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "DisableCommenting",
            "kind": "LinkedField",
            "name": "disableCommenting",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LocalReplyListContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '1d19e7d6b43815bc97bd2d657b60b5b7';
export default node;
